import { motion } from "framer-motion";
import { FiUsers, FiBook, FiBriefcase, FiGlobe } from "react-icons/fi";
import { ReactComponent as AboutPartnerships } from "../../../../../images/web/about/about-partner-svg.svg";
import Constaint from "../../../layout/components/Constaint";

const PARTNERSHIP_TYPES = [
  { icon: FiUsers, label: "Education Consultants" },
  { icon: FiBook, label: "Admissions Partners" },
  { icon: FiBriefcase, label: "Immigration Attorneys" },
  { icon: FiGlobe, label: "HR & Corporate Teams" },
];

const CompanyValues = () => {
  return (
    <Constaint>
      <section className="relative overflow-hidden bg-white-f9 w-full">
        {/* Ambient blob */}
        <div className="pointer-events-none absolute -left-16 bottom-0 h-72 w-72 rounded-full bg-blue-ea/50 blur-3xl" />

        <div className="flex flex-col lg:flex-row lg:min-h-svh lg:items-center">
          {/* Content */}
          <div className="relative w-full lg:w-3/5 py-24 lg:py-32">
              <motion.div
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.65 }}
              >
                <p className="inline-flex rounded-full border border-blue-ea bg-white px-4 py-2 text-xs font-semibold uppercase tracking-widest text-blue-00">
                  Partner With Us
                </p>

                <h2 className="mt-5 text-4xl font-light font-lato leading-tight tracking-tight text-black-1a sm:text-5xl">
                  Partner
                  <span className="text-blue-00 italic mx-2">With</span>
                  Us
                </h2>

                <p className="mt-6 text-lg leading-8 text-dark-6b">
                  At SeamlessVisa, collaboration means innovation. We're
                  building bridges between technology and human expertise, and
                  we'd love for you to join us. Gain access to our expert visa
                  processing support, international admissions program, and our
                  flagship AI tool, FiBi — the consular interview simulator
                  transforming how education consultants, attorneys, and HR
                  teams prepare their clients for success.
                </p>

                <p className="mt-4 text-lg leading-8 text-dark-6b">
                  Whether you're looking to scale your training or provide more
                  reliable outcomes, our warm and professional team is here to
                  support your mission. Let's do more together.
                </p>

                <div className="mt-8 grid grid-cols-2 gap-3">
                  {PARTNERSHIP_TYPES.map(({ icon: Icon, label }) => (
                    <div
                      key={label}
                      className="flex items-center gap-3 rounded-xl border border-blue-ea bg-white px-4 py-3"
                    >
                      <Icon className="h-4 w-4 shrink-0 text-blue-00" />
                      <span className="text-sm text-dark-4e">{label}</span>
                    </div>
                  ))}
                </div>

                <p className="mt-8 text-base text-dark-6b">
                  Connect with our partnerships team at{" "}
                  <a
                    href="mailto:connect@seamlessvisa.com"
                    className="font-semibold text-blue-00 underline underline-offset-4 transition-all duration-300 hover:text-blue-02"
                  >
                    connect@seamlessvisa.com
                  </a>{" "}
                  and let's start the conversation.
                </p>
              </motion.div>
          </div>

          {/* SVG — column on mobile, overlay on desktop */}
          <div className="relative w-full lg:absolute lg:inset-y-0 lg:right-0 lg:w-2/5 h-64 lg:h-full lg:pointer-events-none">
            {/* Fade edge for desktop overlay */}
            <div className="hidden lg:block absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-white-f9 to-transparent z-10" />
            <AboutPartnerships className="h-full w-full object-cover" />{" "}
          </div>
        </div>
      </section>
    </Constaint>
  );
};

export default CompanyValues;
